import React from 'react';
import styles from '../../pop-up.module.scss';
import { Box, TextField, Typography } from '@mui/material';
import CTA from '../../../CTA';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { changePaydayClient } from '../../../../api/suppliers';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { getArrayOfErrors } from 'utils/errors';
import { useDispatch } from 'react-redux';
import { setErrorToken } from '../../../../redux/authSlice/authSlice';

export const ChangePayday = ({ name, setShowModal, clientId, currentPayday }) => {
  const { user, token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [payday, setPayday] = useState(currentPayday || '');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (event) => {
    const value = event.target.value;
    // Solo permitir numeros enteros positivos
    if (value === '' || /^\d+$/.test(value)) {
      setPayday(value);
    }
  };

  const changePayday = async () => {
    if (!payday || payday === '') {
      toast.error('Por favor ingresa un plazo en días');
      return;
    }

    setLoading(true);

    try {
      const data = {
        payday: payday,
        restaurantId: clientId.toString(),
      };
      await changePaydayClient(user?.supplierId, data, token);

      toast.success('Se actualizó el plazo de pago correctamente');
      setTimeout(() => {
        setShowModal(false);
        setLoading(false);
        navigate('/clientes');
      }, 500);
    } catch (error) {
      if (error.response) {
        const errors = getArrayOfErrors(error.response.data);

        if (
          error.response.data === 'Su token ha caducado por favor vuelve a iniciar sesión'
        ) {
          dispatch(setErrorToken(true));
          setLoading(false);
          setShowModal(false);
        } else {
          for (let i = 0; i < errors.length; i++) {
            toast.error(errors[i]);
          }
          setLoading(false);
        }
      } else {
        toast.error('Error interno. Inténtelo más tarde');
        setLoading(false);
      }
    }
  };

  return (
    <div className={styles.content}>
      <h1 className={styles.title}>Condiciones de crédito</h1>

      <Box>
        <Typography>{`Ingresa el plazo en días para ${name}`}</Typography>
      </Box>

      <Box mt={2}>
        <TextField
          label="Plazo en días"
          value={payday}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          type="text"
          inputProps={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
          }}
          helperText="Ingresa solo números enteros"
        />
      </Box>

      <Box mt={2}>
        <CTA isDisabled={loading || !payday} text="Guardar" onClick={changePayday} />
      </Box>
    </div>
  );
};
